import { render, staticRenderFns } from "./videoDigital.vue?vue&type=template&id=1eb8943b&scoped=true&"
import script from "./videoDigital.vue?vue&type=script&lang=js&"
export * from "./videoDigital.vue?vue&type=script&lang=js&"
import style0 from "./videoDigital.vue?vue&type=style&index=0&id=1eb8943b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8943b",
  null
  
)

export default component.exports